import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "data-table-container" }
const _hoisted_2 = { class: "data-table-title-container" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "data-table-title-container-text" }
const _hoisted_5 = { class: "data-table-title-container-icon" }
const _hoisted_6 = {
  key: 0,
  "aria-hidden": "true",
  class: "q-icon fa-light fa-chevron-up",
  role: "presentation",
  style: {"font-size":"20px"}
}
const _hoisted_7 = {
  key: 1,
  "aria-hidden": "true",
  class: "q-icon fa-light fa-chevron-down",
  role: "presentation",
  style: {"font-size":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_add_code = _resolveComponent("add-code")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.collapseType === 'expansion')
      ? (_openBlock(), _createBlock(_component_q_expansion_item, {
          key: 0,
          "model-value": true,
          class: "io-mfe-ig-expansion-item"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_q_markup_table, {
              class: "data-table",
              dense: "",
              flat: "",
              "hide-bottom": ""
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "dt-thead"),
                (!_ctx.dragDisallowed)
                  ? (_openBlock(), _createBlock(_component_draggable, {
                      key: 0,
                      list: _ctx.rows,
                      "item-key": "id",
                      tag: "tbody",
                      onUpdate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reorder', $event))),
                      onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dragStart', $event)))
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "dt-rows")
                      ]),
                      _: 3
                    }, 8, ["list"]))
                  : _renderSlot(_ctx.$slots, "dt-rows", { key: 1 }),
                _createVNode(_component_add_code, {
                  columns: _ctx.columns || [],
                  type: _ctx.type
                }, null, 8, ["columns", "type"])
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    (_ctx.collapseType === 'icon-based')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "data-table-title-container data-table-title-container-icon-based",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = !_ctx.open))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createElementVNode("span", _hoisted_5, [
              (_ctx.open)
                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                : (_openBlock(), _createElementBlock("i", _hoisted_7))
            ])
          ]),
          (_ctx.open)
            ? (_openBlock(), _createBlock(_component_q_markup_table, {
                key: 0,
                class: "data-table",
                dense: "",
                flat: "",
                "hide-bottom": ""
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "dt-thead"),
                  (!_ctx.dragDisallowed)
                    ? (_openBlock(), _createBlock(_component_draggable, {
                        key: 0,
                        list: _ctx.rows,
                        "item-key": "id",
                        tag: "tbody",
                        onUpdate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('reorder', $event))),
                        onStart: _cache[4] || (_cache[4] = ($event: any) => (!_ctx.dragDisallowed && _ctx.$emit('dragStart', $event)))
                      }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "dt-rows")
                        ]),
                        _: 3
                      }, 8, ["list"]))
                    : _renderSlot(_ctx.$slots, "dt-rows", { key: 1 }),
                  _createVNode(_component_add_code, {
                    columns: _ctx.columns || [],
                    type: _ctx.type
                  }, null, 8, ["columns", "type"])
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}